import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class ServersCreateFromBackupRoute extends Route {
  @service store;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  model() {
    let { project } = this.modelFor("organization");
    let dataCenters = this.store.peekAll("data-center");

    return { project, dataCenters };
  }

  resetController(controller) {
    controller.scheduleReload.cancelAll();
    controller.loadBackups.cancelAll();
  }
}
